enum LayerDataType {
  SEGMENT = "segment",
  POINT = "point",
  CRACKSEAL = "crackseal",
  POTHOLE = "pothole",
  ROADSENSEPOINT = "roadSensePoint",
}

export default LayerDataType;
